import { PILLARS } from "@/lib/constants";
import { useReveal } from "@/hooks/useReveal";

const PillarCard = ({ index, title, body, delay = 0 }) => {
  const { ref, shown } = useReveal();
  return (
    <div
      ref={ref}
      data-testid={`pillar-card-${index}`}
      className={`flex flex-col reveal ${shown ? "in" : ""}`}
      style={{ transitionDelay: `${delay}ms` }}
    >
      <div className="h-px w-full bg-accent" />
      <div className="pt-8 flex flex-col gap-5">
        <span className="text-xs uppercase tracking-[0.3em] text-accent font-semibold">
          {String(index).padStart(2, "0")}
        </span>
        <h3 className="font-serif text-3xl sm:text-4xl text-primary leading-tight">
          {title}
        </h3>
        <p className="text-base sm:text-lg text-muted-foreground leading-relaxed max-w-md">
          {body}
        </p>
      </div>
    </div>
  );
};

export const About = () => {
  return (
    <section
      id="about"
      data-testid="about-section"
      className="py-24 sm:py-32 border-t border-border"
    >
      <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12">
        <div className="grid lg:grid-cols-12 gap-10 mb-16 sm:mb-24">
          <div className="lg:col-span-5">
            <div className="flex items-center gap-4 mb-8">
              <span className="h-px w-10 bg-accent" />
              <span className="text-[11px] uppercase tracking-[0.32em] text-accent font-semibold">
                The Firm
              </span>
            </div>
            <h2
              data-testid="about-headline"
              className="font-serif text-4xl sm:text-5xl lg:text-6xl text-primary leading-[1.05] tracking-tight text-balance"
            >
              Built like operators. <br className="hidden sm:block" />
              <em className="italic">Capitalized like investors.</em>
            </h2>
          </div>
          <div className="lg:col-span-6 lg:col-start-7 flex items-center">
            <p
              data-testid="about-body"
              className="text-lg sm:text-xl text-muted-foreground leading-relaxed text-pretty"
            >
              Duneworth identifies markets where modern software, distribution,
              and operational rigor can compound for decades. We build companies
              from the inside out — owning what we build, and building what we
              believe will last.
            </p>
          </div>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-12 lg:gap-16">
          {PILLARS.map((pillar, i) => (
            <PillarCard
              key={pillar.title}
              index={i + 1}
              title={pillar.title}
              body={pillar.body}
              delay={i * 120}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default About;
